import { cn } from '@/lib/utils'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import * as React from 'react'

function Popover({
    ...props
}: React.ComponentProps<typeof PopoverPrimitive.Root>) {
    return <PopoverPrimitive.Root data-slot="popover" {...props} />
}

function PopoverTrigger({
    ...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
    return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
}

function PopoverContent({
    className,
    align = 'center',
    sideOffset = 0,
    children,
    arrow = true,
    ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content> & {
    arrow?: boolean
}) {
    return (
        // Portado para o `body`: dentro de um diálogo o conteúdo era cortado
        // pelo `overflow` dele.
        <PopoverPrimitive.Portal>
            <PopoverPrimitive.Content
                data-slot="popover-content"
                align={align}
                sideOffset={sideOffset}
                className={cn(
                    'bg-popover text-popover-foreground',
                    'data-[state=open]:animate-in data-[state=closed]:animate-out',
                    'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
                    'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
                    'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2',
                    'data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
                    'z-(--z-flutuante) max-w-[500px] text-wrap text-base font-normal',
                    '[transform-origin:var(--radix-popover-content-transform-origin)]',
                    'rounded-md border p-4 shadow-md outline-hidden',
                    className,
                )}
                {...props}
            >
                {children}
                {arrow && <PopoverPrimitive.Arrow />}
            </PopoverPrimitive.Content>
        </PopoverPrimitive.Portal>
    )
}

const PopoverAnchor = React.forwardRef<
    React.ComponentRef<typeof PopoverPrimitive.Anchor>,
    React.ComponentProps<typeof PopoverPrimitive.Anchor>
>(({ ...props }, ref) => (
    <PopoverPrimitive.Anchor ref={ref} data-slot="popover-anchor" {...props} />
))
PopoverAnchor.displayName = PopoverPrimitive.Anchor.displayName

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger }
